/**
 * The `:format?` segment for ROUTES.FLYER_BUILDER.
 *
 * PAD-32920 — an uploaded PDF design has `format: ""`. react-router's
 * generatePath skips an `undefined` optional param but validates `""` against
 * `[^\/]+?` and throws ("Expected "format" to match … but received """), so
 * "Add Address Box" died before navigating. Fall back to the campaign's own
 * format, as the legacy flyer flow does (flyerTypePage: `designFormat || flyerType`),
 * and never hand generatePath an empty string.
 */
export const builderFormat = (designFormat?: string | null, campaignFormat?: string | null): string | undefined =>
  designFormat || campaignFormat || undefined;
